"use Client";
import React from "react";
import Select from 'react-select';
import "./HeaderNavigation.styles.scss";
import Image from "next/image";
import Link from "next/link";
import MenuOverlay from "@/components/MenuOverlay";

const HeaderNavigation = ({ containerProps, containerMethods }) => {
  const { cities, isMenuOpen, city } = containerProps;
  const { toggleMenu, handleCityChange } = containerMethods;
  const hideSearchFunctionality = true;
  return (
    <header className={"headerContainer"}>
      <div className={"topRow"}>
        <div className={"logo"}>
          <Link href={"/"}>
            <Image
              src={
                "https://assets.turnoclub.com/developer/offer-turno-images/S3/innovolt/logo.svg"
              }
              alt="innovolt"
              width={100}
              height={25}
            />
          </Link>
        </div>
        <div className={"rightMenu"}>
          <Select
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              borderRadius: "4px",
               border: "1px solid #C4C4C4",
              boxShadow: "none",
              fontSize: "16px",
              fontFamily: "Inter",
              fontWeight: "500",
            }),
            option: (baseStyles, { isFocused, isSelected }) => ({
              ...baseStyles,
              fontFamily: "Inter",
              fontSize: "12px",
            }),
          }}
          options={cities} 
          instanceId="custom-select2"
          value={cities?.find(option => option?.value === city) || ''}
          onChange={handleCityChange}
          />
          <div className={"menuBar"} onClick={toggleMenu}>
            <Image
              src="http://assets.turnoclub.com/developer/innovolt/icons/menu-icon.svg"
              alt="menu-icon"
              width={28}
              height={28}
            />
          </div>
        </div>
      </div>
      {!hideSearchFunctionality && <div className={"searchRow"}>
        <div className={"searchContainer"}>
          <div className="searchLogo">
            <Image
              src="https://assets.turnoclub.com/developer/innovolt/icons/search-icon.svg"
              alt="search icon"
              width={20}
              height={20}
            />
          </div>
          <input
            type="text"
            placeholder="Search vehicle name here"
            className={"searchInput"}
          />
        </div>
      </div>}
      <MenuOverlay isMenuOpen={isMenuOpen} toggleMenu={toggleMenu}/>
    </header>
  );
};

export default HeaderNavigation;
